import { getActiveCards } from './getActiveCards';

export const cardOperations = {
  getActiveCards
};
